export const lastSeenPropertiesCustomSection = "Ostatnio oglądane";
export const lastSeenPropertiesCustomSection = "Ostatnio oglądane";
